export default {
  global: 'global',
  // phan quyen
  // 'admin.customer.list': 'Xem danh sách khách hàng',
  // 'admin.customer.create': 'Thêm mới khách hàng',
  // 'admin.customer.detail': 'Xem chi tiết khách hàng',
  // 'admin.customer.update': 'Cập nhật thông tin khách hàng',
  // 'admin.customer.remove': 'Xoá khách hàng',
  // 'admin.customer.export': 'Download thông tin khách hàng',

  // 'admin.potential_customer.list': 'Xem danh sách khách hàng tiềm năng',
  // 'admin.potential_customer.create': 'Thêm mới khách hàng tiềm năng',
  // 'admin.potential_customer.detail': 'Xem chi tiết khách hàng tiềm năng',
  // 'admin.potential_customer.update': 'Cập nhật thông tin khách hàng tiềm năng',
  // 'admin.potential_customer.remove': 'Xoá khách hàng tiềm năng',

  // 'admin.customer_history.list': 'Xem lịch sử làm việc khách hàng',
  // 'admin.customer_history.create': 'Thêm mới lịch sử làm việc khách hàng',
  // 'admin.customer_history.remove': 'Xoá lịch sử làm việc khách hàng',

  // 'admin.datacenter_request.list': 'Xem danh sách yêu cầu Datacenter',
  // 'admin.datacenter_request.create': 'Thêm mới yêu cầu Datacenter',
  // 'admin.datacenter_request.detail': 'Xem chi tiết yêu cầu Datacenter',
  // 'admin.datacenter_request.remove': 'Xoá yêu cầu Datacenter',
  // 'admin.datacenter_request.export': 'Download danh sách yêu cầu Datacenter',

  // 'admin.documentation.list': 'Xem danh sách tài liệu',
  // 'admin.documentation.create': 'Thêm mới tài liệu',
  // 'admin.documentation.detail': 'Xem chi tiết tài liệu',
  // 'admin.documentation.update': 'Cập nhật thông tin tài liệu',
  // 'admin.documentation.remove': 'Xoá tài liệu',

  // 'admin.notification.list': 'Xem danh sách thông báo',
  // 'admin.notification.create': 'Thêm mới thông báo',
  // 'admin.notification.detail': 'Xem chi tiết thông báo',
  // 'admin.notification.update': 'Cập nhật thông báo',
  // 'admin.notification.remove': 'Xoá thông báo',

  // 'admin.partner.list': 'Xem danh sách đối tác',
  // 'admin.partner.create': 'Thêm mới đối tác',
  // 'admin.partner.detail': 'Xem chi tiết đối tác',
  // 'admin.partner.update': 'Cập nhật thông tin đối tác',
  // 'admin.partner.remove': 'Xoá đối tác',

  // 'admin.product.list': 'Xem danh sách dịch vụ',
  // 'admin.product.create': 'Thêm mới dịch vụ',
  // 'admin.product.detail': 'Xem chi tiết dịch vụ',
  // 'admin.product.update': 'Cập nhật thông tin dịch vụ',
  // 'admin.product.remove': 'Xoá dịch vụ',
  // 'admin.product.send_postage': 'Gửi thông báo cước dịch vụ',
  // 'admin.product.send_overload_alert': 'Gửi thông báo quá tải',
  // 'admin.product.export': 'Download danh sách dịch vụ',

  // 'admin.product_category.list': 'Xem danh sách danh mục dịch vụ',
  // 'admin.product_category.create': 'Thêm mới danh mục dịch vụ',
  // 'admin.product_category.detail': 'Xem chi tiết danh mục dịch vụ',
  // 'admin.product_category.update': 'Cập nhật thông tin danh mục dịch vụ',
  // 'admin.product_category.remove': 'Xoá danh mục dịch vụ',

  // 'admin.service.list': 'Xem danh sách sản phẩm',
  // 'admin.service.create': 'Thêm mới sản phẩm',
  // 'admin.service.detail': 'Xem chi tiết sản phẩm',
  // 'admin.service.update': 'Cập nhật thông tin sản phẩm',
  // 'admin.service.remove': 'Xoá sản phẩm',

  // 'admin.support_request.list': 'Xem danh sách yêu cầu hỗ trợ',
  // 'admin.support_request.create': 'Tạo yêu cầu hỗ trợ',
  // 'admin.support_request.detail': 'Xem chi tiết yêu cầu hỗ trợ',
  // 'admin.support_request.update': 'Cập nhật yêu cầu hỗ trợ',
  // 'admin.support_request.response': 'Phản hồi hỗ trợ',

  // 'admin.user.list': 'Xem danh sách user',
  // 'admin.user.create': 'Thêm mới user',
  // 'admin.user.detail': 'Xem chi tiết user',
  // 'admin.user.update': 'Cập nhật thông tin user',
  // 'admin.user.remove': 'Xoá user',

  // 'admin.permissions.list': 'Xem danh sách quyền',
  // 'admin.permissions.update': 'Phân quyền',
  // 'admin.permissions.get_by_role': 'Lấy danh sách quyền theo vai trò',

  // 'admin.task.list': 'Xem danh sách công việc hằng ngày',
  // 'admin.task.create': 'Thêm mới công việc hằng ngày',
  // 'admin.task.detail': 'Xem chi tiết công việc hằng ngày',
  // 'admin.task.update': 'Cập nhật thông tin công việc hằng ngày',
  // 'admin.task.remove': 'Xoá công việc hằng ngày',

  // 'admin.role.list': 'Xem danh sách vai trò',
  // 'admin.role.create': 'Thêm mới vai trò',
  // 'admin.role.detail': 'Xem chi tiết vai trò',
  // 'admin.role.update': 'Cập nhật thông tin vai trò',
  // 'admin.role.remove': 'Xoá vai trò',

  // 'admin.business.get_revenue_in_month': 'Xem báo cáo doanh thu trong tháng',
  // 'admin.business.get_report': 'Xem báo cáo của nhân viên',
  // 'admin.business.list_transaction': 'Xem lịch sử giao dịch',
  // 'admin.business.create_transaction': 'Tạo mới giao dịch',
  // 'admin.business.detail_transaction': 'Xem chi tiết giao dịch',
  // 'admin.business.update_transaction': 'Cập nhật giao dịch',
  // 'admin.business.remove_transaction': 'Xoá giao dịch',
  // 'admin.potential_customer.import': 'Import từ Excel',

  // 'admin.warehouse.list': 'Xem danh sách thiết bị trong kho',
  // 'admin.warehouse.create': 'Thêm mới thiết bị vào kho',
  // 'admin.warehouse.detail': 'Xem chi tiết thiết bị',
  // 'admin.warehouse.update': 'Cập nhật thông tin thiết bị',
  // 'admin.warehouse.remove': 'Xoá thiết bị',

  // 'admin.order.list': 'Xem danh sách yêu cầu mua hàng',
  // 'admin.order.detail': 'Xem chi tiết yêu cầu mua hàng',
  // 'admin.order.update': 'Cập nhật yêu cầu mua hàng',

  // 'admin.shop.list': 'Xem danh sách gian hàng đối tác',
  // 'admin.shop.create': 'Thêm mới gian hàng đối tác',
  // 'admin.shop.detail': 'Xem chi tiết gian hàng đối tác',
  // 'admin.shop.update': 'Cập nhật thông tin gian hàng đối tác',
  // 'admin.shop.remove': 'Xoá gian hàng đối tác',

  // 'admin.service_category.list': 'Xem danh sách danh mục sản phẩm',
  // 'admin.service_category.create': 'Thêm mới danh mục sản phẩm',
  // 'admin.service_category.detail': 'Xem chi tiết danh mục sản phẩm',
  // 'admin.service_category.update': 'Cập nhật thông tin danh mục sản phẩm',
  // 'admin.service_category.remove': 'Xoá danh mục sản phẩm',

  // 'admin.mail.send': 'Gửi mail tới khách hàng',
  // 'admin.mail.send_many': 'Gửi thông báo chăm sóc (tới nhiều khách hàng)',
  // 'admin.mail.get_template': 'Xem mẫu email',
  // 'admin.mail.set_template': 'Cập nhật mẫu email',

  // 'admin.web_customer.list': 'Xem danh sách khách hàng từ web',
  // 'admin.web_customer.detail': 'Xem chi tiết khách hàng từ web',
  // 'admin.web_customer.update': 'Cập nhật khách hàng từ web',
  // 'admin.web_customer.remove': 'Xoá khách hàng từ web',

  // 'admin.export.customer': 'Download dữ liệu khách hàng',
  // 'admin.export.product':
  //   'Download dữ liệu dịch vụ (bao gồm đang chạy, cắt huỷ, tạm dừng)',
  // 'admin.export.datacenter_request': 'Download yêu cầu datacenter',
  // 'admin.export.support_request': 'Download yêu cầu hỗ trợ từ khách hàng',
  // 'admin.export.customer_history': 'Download lịch sử làm việc với khách hàng',
  // 'admin.export.product_history': 'Download lịch sử thay đổi dịch vụ',
  // 'admin.export.product_overload': 'Download thông báo dịch vụ quá tải',
  // 'admin.product_overload.list': 'Xem danh sách thông báo quá tải',

  // 'admin.customer_support_calls.list': 'Xem danh sách khách hàng cần chăm sóc',
  // 'admin.customer_support_calls.create': 'Tạo ghi chú sau khi chăm sóc',

  // card title
  // 'admin.customer': 'Khách hàng',
  // 'admin.customer_history': 'Lịch sử làm việc khách hàng',
  // 'admin.datacenter_request': 'Yêu cầu datacenter',
  // 'admin.documentation': 'Tài liệu',
  // 'admin.notification': 'Thông báo khuyến mãi',
  // 'admin.partner': 'Đối tác datacenter',
  // 'admin.permissions': 'Phân quyền',
  // 'admin.potential_customer': 'Khách hàng tiềm năng',
  // 'admin.product': 'Dịch vụ',
  // 'admin.product_category': 'Danh mục dịch vụ',
  // 'admin.role': 'Quản lý vai trò',
  // 'admin.service': 'Sản phẩm đối tác',
  // 'admin.support_request': 'Yêu cầu hỗ trợ',
  // 'admin.task': 'Công việc hằng ngày',
  // 'admin.user': 'User',
  // 'admin.warehouse': 'Kho thiết bị',
  // 'admin.business': 'Báo cáo kinh doanh',
  // 'admin.shop': 'Gian hàng đối tác',
  // 'admin.order': 'Yêu cầu mua hàng',
  // 'admin.service_category': 'Danh mục sản phẩm đối tác',
  // 'admin.mail': 'Mail',
  // 'admin.web_customer': 'Khách hàng từ web',
  // 'admin.export': 'Download dữ liệu',
  // 'admin.product_overload': 'Thông báo quá tải',
  // 'admin.customer_support_calls': 'Chăm sóc khách hàng',
  // 'global.avatar': 'Ảnh',
  // 'global.full_name': 'Họ tên',
  // 'global.created': 'Ngày đăng kí',
  'global.signout': 'Déconnexion',
  'global.account_information': 'Mon compte',
  'global.role': 'Role',
  'global.add': 'Add New',
  // 'global.edit': 'Sửa',
  'global.password': 'Password',
  'global.resetpassword': 'Reset password',
  'global.input_password': 'Input password',
  'global.is_verified_email': 'Verify email',
  'global.is_mobile_verified': 'Verify phone',
  'global.unverified': 'Unverified',
  'global.verified': 'Verified',
  // 'global.admin': 'Quản trị viên',
  // 'global.staff': 'Nhân viên',
  // 'global.gender': 'Giới tính',
  // 'global.date_of_bird': 'Date of birth',
  // 'global.identity': 'CMT/CCCD',
  // 'global.bhyt': 'BHYT',
  // 'global.nam': 'Nam',
  // 'global.nu': 'Nữ',
  // 'global.ngay_cap': 'Ngày cấp',
  // 'global.noi_cap': 'Nơi cấp',
  // 'global.so_bhyt': 'Số BHYT',
  // 'widgets.recentNotifications': 'Thông báo gần đây',
  // 'button.viewAll': 'Xem tất cả',
  // 'widgets.recentMessage': 'Tin nhắn gần đây',
  // 'global.user': 'Người dùng',
  // 'global.status': 'Trạng thái',
  'global.status': 'Status',
  'global.add_new': 'Add new',
  'global.published': 'Published',
  'global.unpublished': 'Unpublished',
  'global.delete': 'Delete',
  'global.copy': 'Copy',
  'global.create': 'Create',
  'global.update': 'Update',
  'global.image': 'Image',
  'global.image_alt': 'Alternative image',
  'global.schema_type': 'Schema type',
  'global.title': 'Title',
  'global.slug': 'Slug',
  'global.sub_title': 'Sub title',
  'global.company': 'Company',
  'global.id': 'ID',
  'global.tabbasic': 'Basic',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Cancel',
  'global.active': 'Active',
  'global.inactive': 'Inactive',
  'global.deactivate': 'Deactivate',
  'global.submit': 'Submit',
  'global.edit': 'Edit',
  'global.trashed': 'Trashed',
  'global.approved': 'Approved',
  'global.approve': 'Approve',
  'global.from': 'From',
  'global.to': 'To',
  'global.price_discount': 'Price discount',
  'global.price_roundtrip': 'Price roundtrip',
  'global.price': 'Prix',
  'global.infant_price': 'Infant price',
  'global.car': 'Car',
  'global.type': 'Type',
  'global.rating': 'Rating',
  'global.room_rate': 'Room rate',
  'global.cancel_policy': 'Cancel policy',
  'global.policy': 'Policy',
  'global.instant_bookable': 'Instant bookable',
  'global.yes': 'Yes',
  'global.no': 'No',
  'global.city': 'City',
  'global.street': 'Street',
  'global.neighbourhood_cleansed': ' Cleansed',
  'global.neighbourhood_group_cleansed': ' Group cleansed',
  'global.location': 'Location',
  'global.choose-location': 'Choose location',
  'global.square_feet': 'Square Feet',
  'global.bedrooms': 'Bedrooms',
  'global.bathrooms': 'Bathrooms',
  'global.beds': 'Beds',
  'global.bed_type': 'Bed_type',
  'global.cover_img': 'Cover image',
  'global.gallery': 'Gallery',
  'global.gallerySetting': 'Gallery Setting',
  'global.security_deposit': 'Security deposit ',
  'global.guests_included': 'Guests included',
  'global.minimum_nights': 'Minimum nights',
  'global.cleaning_fee': 'Cleaning fee',
  'global.extra_people': 'Extra people',
  'global.maximum_nights': 'Maximum nights',
  'global.month': 'Month',
  'global.calendar': 'Calendar',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Ward',
  'global.no_house': 'House number',
  'global.nearbyUtils': 'Near by utils',
  'global.extra_price': 'Extra price',
  'global.patients': 'Patients',
  'global.setting': 'Paramètres',
  'global.appointments': 'Appointments',
  'global.suppliers': 'Suppliers',
  'global.id_number': 'ID',
  'global.code': 'Code',
  'global.name': 'Name',
  'global.services': 'Services',
  'global.clinic': 'Clinic',
  'global.website': 'Website',
  'global.contact_name': 'Contact',
  'global.refresh': 'Refresh',
  'global.distance': 'Distance',

  'car.driver': 'Driver',
  'car.seat': 'Seat',
  'car.luggage': 'Luggage',
  'car.ordering': 'Booking',
  'car.facility': 'Facility',
  'car.air_machine': 'Air machine',
  'car.energy_saving': 'Energy saving',
  'car.stop_point': 'Stop point',
  'property.start_date': 'Start date ',
  'property.end_date': 'End date',
  'property.price_week': 'Price week',
  'property.weekend_price': 'Price weekend',
  'property.extra_price': 'Extra price',
  'property.host_languages': ' Host languages',
  'property.week_term_promo': 'Week term promo',
  'property.month_term_promo': 'Month term promo',
  'property.price_weekend': 'Price weekend',
  'global.guests_standard': 'Guests standard',
  'global.guests_max': 'Guests max',
  'sidebar.transport': 'Transport',
  'sidebar.amenity': 'Amenity',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.property': 'Property',
  'sidebar.property_type': 'Property type',
  'sidebar.room': 'Room',
  'sidebar.cancel_policy': 'Cancel policy',
  'sidebar.vehicle': 'Vehicle',
  'sidebar.car': 'Car',
  'sidebar.route': 'Route',
  'sidebar.routes': 'Routes',
  'sidebar.inbox': 'Inbox',
  'sidebar.conversation': 'Conversation',
  'sidebar.reservations': 'Reservations',
  'sidebar.earning': 'Earning',
  'sidebar.calendar': 'Calendar',
  'sidebar.reports': 'Reports',
  'sidebar.services': 'Services',
  'sidebar.addons_order': 'Additional services',
  'sidebar.debt_confirmation_record': 'Debt confirmation record',
  'global.requiredfield': 'Required field',
  'sidebar.account': 'Account',

  'property.room_type': 'Room type',
  'global.propertytypes': 'Property type',
  'global.save': 'Save',
  'global.save_and_close': 'Save & close',
  'global.signin': 'Sign in',
  'global.signup': 'Signup',
  'global.forgot_password': 'Forgot password',
  'global.search_placeholder': 'Search',

  'global.seat_map': 'Seat map',
  'global.vehicles': 'Vehicles',
  'global.row': 'Row',
  'global.column': 'Column',

  'placeholder.select_operator': 'Select operator',
  //routes
  'global.vehicle': 'Vehicles',
  'global.sku': 'SKU',
  'global.add_segment': 'Add Segment',
  'global.add_price': 'Add Price',
  'global.create_return_route': 'Create Return Route',
  'global.create_price_ddd': 'Create Price DDD',
  'global.delete_confirm': 'Confirm Delete',
  'global.end_time': 'End time',
  'global.adult_price': 'Adult price',
  'global.segment': 'Segment',
  'global.show_seat_map': 'Show seat map',
  'global.weekdays': 'Week days',

  //seat
  'global.chosen': 'Chosen',
  'global.taken': 'Taken',
  'global.locked': 'Locked',
  'global.free': 'Free',

  //menus
  'global.menus': 'Menus',
  'global.menu': 'Menu',
  'global.key': 'Key',
  'global.menu_items': 'Menu items',
  'global.menu_item': 'Menu item',

  //trajet
  'global.trajet': 'Trajet',
  'global.lieu_arrivee': 'Lieu Arrivee',
  'global.heure_ramassage': 'Heure Ramassage',
  'global.heure': 'Heure',
  'global.lieu_depart': 'Lieu Depart',
  'global.depart': 'Départs',
  'global.arrivee': 'Arrivee',
  'global.prix': 'Prix',
  'global.sous_trajet_id': 'Sous Trajet Id',
  'global.code_trajet': 'Code Trajet',

  'global.app_id': 'App Id',

  //Register
  'global.registration_header': 'Register form',
  'global.country': 'Country',
  'global.mobile': 'Téléphone',
  'signup.back_to_login': 'Back to login',
  'global.continue': 'Continue',
  'global.close': 'Close',

  //
  'global.statistics': 'Statistics',
  'global.tour_rates': 'Rates',
  'global.tour_options': 'Options',
  'global.destinations': 'Destinations',
  'global.orders': 'Réservations',
  'global.booking_statistics': 'Report de voyage',
  'global.reviews': 'Reviews',
  'global.weekday': 'Weekday',
  'global.statistic': 'Statistic',
  'global.view_seat_map': 'View seat map',
  'global.booked_seat': 'Booked seat',
  'global.disabled_seats': 'Disabled seat',
  'global.preview_seat_map': 'Preview seat map',

  'global.language': 'Language',
  'global.currency': 'Currency',
  'global.your_plan': 'Plan',
  'global.trial_end': 'Expired date',
  'global.timezone': 'Timezone',
  'global.emai_required': 'Yêu cầu điền email',
  // 'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email không đúng định dạng',
  'global.confirm_password': 'Confirm password',
  'global.changepassword': 'Modifier mot de passe',
  'global.confirm_new_password': 'Confirm new password',
  'global.new_password': 'New password',
  'global.current_password': 'Current password',
  'global.password_not_match': 'Password not match',
  'global.password_min_charactor': '6 characters min',
  'global.home': 'Home',
  'global.username': 'Username',
  'global.sms_settings': 'SMS Settings',
  'global.app_settings': 'App Settings',

  //sms settings
  'global.sender_id': 'SenderID',
  'global.user_app': 'User App',
  'global.operator_app': 'Operator App',

  //user app settings
  'global.app_listing': 'App listing',
  'global.app_status': 'App status',
  'global.booking_message': 'Booking message',
  'global.booking': 'Booking',
  'global.selling_start': 'Selling start',
  'global.any_time': 'Anytime',
  'global.custom': 'Custom',

  // Cabins
  'global.cabins': 'Cabins',
  'global.size': 'Size',
  'global.qty': 'Quantity',
  'global.route': 'Route',
  'global.start_location': 'Start location',
  'global.end_location': 'End location',
  'global.end_location': 'End location',
  'global.duration': 'Duration',
  'global.destination_map': 'Destination map',
  'global.route_markets': 'Route markets',
  'global.please_select_start_and_stop_destination':
    'Please select start and stop destination',
  'placeholder.select_start_location': 'Select start location',
  'placeholder.select_end_location': 'Select end location',

  // Customer Groups
  'global.discount': 'Discount',
  'global.cGroups': 'Customer groups',
  'global.group': 'Group',

  'global.disabled': 'Disabled',
  'global.enabled': 'Enabled',
  'global.tax': 'Tax',

  'global.disabled_seat': 'Disable seat',
  'global.enable_seat': 'Enable seat',
  //
  'global.hops': 'Hops',
  'global.systems': 'Systems',
  'global.start_time': 'Start time',
  'global.start_stop': 'Destination start',
  'global.end_stop': 'Destination end',
  'global.cabin-rates': 'Cabin rates',
  'global.title_route': 'Route',

  // Addons
  'global.addons': 'Additional services',
  'global.seat': 'Seat',
  'global.from_date': 'From',
  'global.to_date': 'To date',

  'global.order_group': 'Booking group',
  'global.route_tital': 'Route',
  'global.select_customer': 'Select customer',
  'global.select_option': 'Select option',
  'global.order_status': 'Booking status',
  'global.order_cancel': 'Are you sure want to cancel this order?',
  'order.pax': 'Pax',
  'global.passport': 'Passport',
  'global.addnew': 'Add',
  'global.select_county': 'Select county',
  'global.cabin': 'Cabin',
  'global.price_type': 'Price type',
  'global.voucher': 'Voucher',
  'global.passengers': 'Passagers',
  'global.notes': 'Notes',
  'global.order_id': 'Booking ID',
  'global.select_date': 'Select date',
  'global.select_hops': 'Select hop',
  'global.pay_status': 'Pay status',
  'global.select_pay_status': 'Statut du paiement',
  'bill.serial': 'Serial',
  'bill.billed_date': 'Payment date',
  'bill.amount': 'Amount',
  'global.method': 'Method',
  'global.payment_method': 'Payment method',
  'global.bills': 'Payment ',
  'global.notpaid': 'Not paid',
  'global.paid': 'Paid',
  'global.success': 'Paid',
  'global.collect': 'Collect',
  'global.spend': 'Spend',
  'global.cash': 'Cash',
  'global.card': 'Card',
  'global.bank': 'Bank',
  'global.insurance': 'Insurance',
  'global.select_customers': 'Select customer',
  'global.select_types': 'Select type',
  'sidebar.dept': 'AR',
  'global.total_debt_begin_period': 'Debt begin period',
  'global.total_paid_begin_period': 'Paid begin period',
  'global.total_debt_in_period': 'Debt in period',
  'global.total_paid_in_period': 'Paid in period',
  'global.total_debt_end_period': 'Total debt',

  'global.ar': 'Account receivable',
  'global.confirm': 'Confirm',
  'global.order_confirm': 'Are you sure want to confirm this order?',
  'global.bill_confirm': 'Are you sure want to approve this bill?',
  // 'global.cabin_rates': 'Cabin rates',
  'global.bookingCalendar': 'Booking calendar',
  'global.invoice': 'Invoice',
  'global.list_order_not_paid': 'List order not paid',
  'global.export_to_excel': 'Export to Excel',
  'global.report_debt_confirmation': 'Debt confirmation record',
  'global.debt': 'AR records',
  'global.bill': 'Payment',
  'global.record': 'Record',
  // report
  'global.date': 'Date',
  'global.day': 'Day',
  'global.hop': 'Hop',
  'global.addon': 'Add-on',
  'global.customer': 'Customer',
  'global.year': 'Year',
  'global.period': 'Period',

  'global.select_menu': 'Select menu',
  'global.select_role': 'Select role',

  'global.add_walk_in_customer': 'Add walk-in customer',
  'global.order_details': 'Booking details',
  'global.cabins_order': 'Cabins order',
  'global.last_30_day': 'Last 30 days',
  'global.last_7_day': 'Last 7 days',
  'global.last_month': 'Last month',
  'global.this_month': 'This month',
  'global.next_month': 'Next month',
  'global.seller': 'Seller',
  'global.send_email': 'Send email',
  'global.sale': 'Sale',
  'global.finance': 'Finance',
  'global.carriages': 'Carriages',
  'global.logo': 'Logo',
  'global.content': 'Content',
  'global.path': 'Path',
  'global.seat_allocation': 'Seat allocation',
  'global.cabinSerials': 'Cabin serials',
  'global.title_carriage': 'Title carriage',
  'global.title_cabin': 'Title cabin',
  'global.select_carriage': 'Select carriage',
  'global.order_seat': 'Booking seat',
  'global.order_seats': 'Booking seats',
  'global.Seat': 'Seat',
  'global.depart_seating': 'Depart seating',
  'global.return_seating': 'Return seating',
  'global.seating': 'Seating',
  'global.summary': 'Summary',
  'global.action': 'Action',
  'global.created_at': 'Created at',
  'global.created_by': 'Created by',
  'global.roundtrip': 'Roundtrip',

  'sites.url': 'URL',
  'sites.ga_script': 'Google analytic script',
  'global.meta_data': 'Meta Data',
  'global.meta_title': 'Meta title',
  'global.meta_description': 'Meta Description',
  'global.meta_keywords': 'Meta Keywords',
  'global.before_head': 'Before Head',
  'global.before_body': 'Before Body',
  'global.layout': 'Layout',
  'global.socials': 'Socials',

  // status
  'global.all': 'All',
  'global.pending': 'Pending',
  'global.confirmed': 'Confirmed',
  'global.cancelled': 'Cancelled',
  'global.refund': 'Refund',
  'global.mark_as_paid': 'Mark as paid',

  'global.super': 'Super',
  'global.admin': 'Admin',
  'global.staff': 'Staff',
  'global.agent': 'Agent',
  'global.upgrade': 'Upgrade',
  'global.cabin_no': 'Cabin No',
  'global.carriage': 'Carriage',
  'global.cabin_type': 'Cabin Type',
  'global.view_seat': 'View Seat',
  'global.view': 'View',
  'global.ok': 'Ok',
  'global.seats': 'Seats',
  'global.time_period': 'Time period',
  'global.booked_seats': 'Booked seats',
  'global.allocated_seat': 'Allocated seat',
  'global.revenue': 'Revenus',
  'global.dashboard': 'Dashboard ',
  'global.revenue_report': 'Revenue report',
  'global.cabins_performance': 'Cabins performance',
  'global.created_date': 'Created date',
  'global.depart_date': 'Depart date',
  'global.download': 'Download',
  'global.permission': 'Permission',
  'global.permissions': 'Permissions',
  'permissions.decline': 'Decline',
  'permissions.allow': 'Allow',
  'global.e_ticket': 'E-Ticket',
  'global.internal_notes': 'Internal notes',
  'global.information_customer': 'Information customer',
  'global.cgroup': 'Customer group',
  'global.order_information': 'Réservation',
  'global.accountant_email': 'Accountant email',
  'global.more': 'more',
  'global.full': 'Full',
  'global.deposited': 'Deposited',
  'global.payment_type': 'Payment type',
  'global.payment_status': 'Payment status',
  'global.contact_information': 'Contact information',
  'global.contacts': 'Contacts',
  'global.contact': 'Contact',
  'global.add_contact': 'Add contact',
  'global.office': 'Office',
  'global.select_contact': 'Select contact',
  'global.select_seller': 'Select seller',
  'global.input_group_code': 'Input code',
  'global.input_pax': 'Input pax',
  'global.input_order_notes': 'Input order notes',
  'global.input_order_internal_notes': 'Input order internal notes',
  'global.input_contact_name': 'Input contact name',
  'global.input_contact_email': 'Input contact email',
  'global.input_contact_mobile': 'Input contact mobile',
  'validate.is_not_email': 'Field is not email',
  'validate.is_not_phone_number': 'Field is not phone number',
  'order.select_other_contact': 'Other',
  'global.select_hop': 'Select a hop',
  'global.select_route': 'Select a route',
  'global.book': 'Book',
  'global.user': 'Utilisateurs',
  'global.save_success': 'Save successfully',
  'global.save_failed': 'Save failed',
  'global.guide_number': 'Guide',
  'global.input_guide_number': 'Input guide',
  'global.input_your_password': 'Please input your password!',
  'global.input_beds': "Please input beds's name or delete this field",
  'global.input_email_or_delete':
    "Please input email's name or delete this field",
  'global.select_destination_start': 'Select destination start',
  'global.select_destination_end': 'Select destination end',
  'placeholder.select_hop': 'Select hop',
  'placeholder.select_addon': 'Select add-on',
  'placeholder.from': 'From',
  'placeholder.to': 'To',
  'placeholder.select_category': 'Select category',
  'placeholder.select_customer_group': 'Select customer group',
  'global.select_user': 'Select user',
  'placeholder.select_user': 'Select user',
  'global.select_permission': 'Select permission',
  'global.select_all': 'Select all',
  'global.advanced_settings_for_each_user': 'Advanced settings for each user',
  'note.reload_page': 'Need to reload the page after finishing editing',
  'global.history': 'History',
  'global.clear': 'Clear',
  'history.from_date': 'From date',
  'history.to_date': 'To date',
  'history.week_days': 'Weekdays',
  'global.reload': 'Reload',
  'global.clear_rate_confirm': 'Are you sure want to clear this data?',
  'placeholder.booking_id_or_code': 'Booking ID or Code',
  'global.special_notes': 'Special notes',
  'placeholder.input_special_notes': 'Input special notes',
  'global.choice_a_time_period': 'Choice a time period',
  'global.not_found': 'Not found',
  'global.select_a_customer': 'Select a customer',
  'placeholder.select_customer': 'Select customer',
  'placeholder.input_notes': 'Input notes',
  'placeholder.input_description': 'Input description',
  'placeholder.select_creator': 'Select creator',
  'placeholder.select_status': 'Select status',
  'placeholder.payment_from': 'Payment from',
  'placeholder.payment_to': 'Payment to',
  'global.initialization_time': 'Initialization time',
  'placeholder.input_title': 'Input title',
  'placeholder.input_code': 'Input code',
  'placeholder.select_route': 'Select route',
  'error.quantity_is_not_the_same':
    'Quantity is not the same as ordered quantity',
  'global.addons_booking': 'Additional services',
  'error.missing_addon': 'Please select an add-on',
  'warning.not_found_carriages': 'No carriages available',
  'global.individual': 'Individual',
  'global.available': 'Available',
  'global.total_number_of_tickets': 'Total number of tickets',
  'global.sold': 'Sold',
  'global.remaining': 'Remaining',
  'global.capacity': 'Capacity',
  'global.general_capacity': 'General capacity',
  'global.files_manager': 'Files manager',
  'error.upload_file': 'Error uploading file. Please try again.',
  'success.upload_file': 'File uploaded successfully!',
  'global.create_folder': 'Create folder',
  'placeholder.input_folder_name': 'Input folder name',
  'global.folder_name': 'Folder name',
  'error.create_folder': 'Error create folder. Please try again.',
  'error.delete_file': 'Error delete, please try again.',
  'error.folder_name': 'Invalid folder name, please try again.',
  'error.missing_file_upload': 'Please select a file to upload.',
  'placeholder.select_date': 'Select date',
  'placeholder.input_email': 'Input email',
  'global.send': 'Send',
  'global.download_addon_booking': 'Download additional services',
  'error.send_email': 'Error send email. Please try again.',
  'global.send_email_success': 'Email sent successfully',
  'global.customer_name': 'Customer name',
  'global.seated_by': 'Seated by',
  'global.seated_date': 'Seated date',
  'sidebar.invoice': 'Invoice',
  'sidebar.vehicles': 'Vehicles',
  'sidebar.seatmap': 'Seat map',
  'global.booked_from': 'Booked from',
  'global.booked_to': 'Booked to',
  'global.amount_of_money': 'Amount of money',
  'global.track': 'Track',
  'placeholder.input_track': 'Input track',
  'global.amenities': 'Amenities',
  'global.icon': 'Icon',
  'error.must_contain_least_one_value':
    'Must contain at least one information of passenger',
  'global.representative_passenger': 'Representative passenger',
  'placeholder.input_firstname': 'Input firstname',
  'placeholder.input_lastname': 'Input lastname',
  'error.missing_passenger_information':
    'Please input least one information of passenger',
  'global.refund_policy': 'Refund Policies',
  'global.refund_policies': 'Refund Policies',
  'global.cancel_fee': 'Cancel fee',
  'global.hours': 'Hours',
  'global.is_default': 'Is Default',
  'global.select_tours': 'Select a tour',
  'global.payments': 'Payments',
  'global.payment_date': 'Payment date',
  'global.payment': 'Payment',
  'global.refund_recording': 'Refund recording',
  'global.transaction': 'Transaction',
  'global.transactions': 'Transactions',
  'global.penalty_date': 'Penalty date',
  'global.today': 'Today',
  'global.penalty_status': 'Penalty status',
  'global.no_payment_yet': 'No payment yet',
  'global.tour': 'Tour',
  'placeholder.input_amount': 'Input amount',
  'success.refund_recorded': 'Refund recorded',
  'global.adults': 'Adults',
  'global.children': 'Children',
  'global.infants': 'Infants',
  'global.pickup_location': 'Pickup location',
  'global.income': 'Income',
  'global.expense': 'Expense',
  'global.pay': 'Pay',
  'global.debit': 'Debit',
  'global.amount': 'Amount',
  'global.transaction_date': 'Transaction date',
  'global.guest_payment_date': 'Transaction date',
  'global.policy_penalty_name': 'Penalty policy name',
  'global.guest_payment': 'Transaction',
  'global.guest_payment_detail': 'Transaction detail',
  'global.waiting_approve': 'Waiting approve',
  'global.created_payments': 'Created payments',
  'tour.pickup_offered': 'Pickup Offered',
  'global.pickup_offer': 'Pickup offer',
  'global.both': 'Both',
  'global.free_cancel': 'Free cancel',
  'global.penalty': 'Penalty',
  'global.cancel_booking': 'Cancel booking',
  'global.pickup_time': 'Pickup time',
  'global.create_transaction': 'Create transaction',
  'global.depart_value': 'Depart value',
  'global.penalty_amount': 'Penalty amount',
  'global.add_pickup': 'Add pickup',
  'global.select_meeting_type': 'Select meeting point type',
  'global.book_tour': 'Book tour: ',
  'global.endWorkingTime': 'End working time',
  'global.merchant_account': 'Merchant account',
  'global.add_stop': 'Add stop',

  'placeholder.select_seat_map': 'Select seat map',
  'placeholder.select_vehicle': 'Select vehicle',

  //payment method
  'global.merchant_id': 'Merchant Id',
  'global.secret_key': 'Secret key',

  //
  'global.send_link_payment': 'Send Link Payment',
  'global.filter_params': 'Filters',
  'global.category_id': 'Category',
  'global.destination_id': 'Destination',

  'global.email': 'Email',
  'global.market': 'Market',
  'global.flat': 'Flat',
  'global.commission_amount': 'Commission amount',

  'global.waiting': 'Waiting',

  'global.select_operators': 'Select Operators',
  'order.supplier_status': 'Supplier Status',
  'global.free_cancel_date': 'Free Cancel Date',
  'global.time_start': 'Time Start',
  'global.supplier_total': 'Supplier Total',
  'global.edit_pickup': 'Edit Pickup',

  'global.drop_off': 'Drop off',
  'global.driver_notes': 'Driver_notes',
  'global.policies': 'Policies',
  'global.cancellation_policy_summary': 'Cancellation',
  'global.service_fee': 'Service fee',
  'global.ordering': 'Ordering',
  'global.price_cron': 'Price cron',
  'global.unit': 'Unit',

  'global.subtotal': 'Subtotal',
  'global.refund_amount': 'Refund amount',
  'global.cancellation_date': 'Cancellation date',
  'global.cancellation_fee': 'Cancellation fee',
  'global.cache_reset': 'Cache reset',
  'global.additional_info': 'Additional info',
  'global.driver': 'Driver',

  'global.select_type': 'Select Type',

  //Revenue
  'global.revenue': 'Revenus',
  'global.trips': 'Voyages',
  'global.sales': 'Ventes',
  'global.paid_ticket': 'Paid ticket',
  'global.filling_rate': 'Taux de remplissage',

  //orders
  'global.travel': 'Voyage',
  'global.booking_info': 'Réservation',
  'global.reference': 'Reference',
  'global.select_pay_method': 'Moyen de paiement',

  //cashier
  'global.cashier': 'Caissiers',
  'global.overview': 'Résumé',
  'global.total': 'Total',
  'global.yobuma': 'Yobuma',
  'global.cashier_name': 'Name',
  'global.balance_pending': 'Caisse',
  'global.closing': 'Date de clôture',
  'global.first_sale': 'Premier billet',
  'global.last_sale': 'Dernier billet',
  'global.detail': 'Detail',
  'global.close_selling': 'Close selling',

  //users operator
  'global.firstname': 'First name',
  'global.lastname': 'Last name',
  'global.phone': 'Phone',
  'global.hotline': 'Hot line',
  'global.short_name': 'Short name',
  'global.limit_order_start_time': 'Limit order start time',
  'global.allow_change_order_after_departure_hour':
    'Allow change order after departure hour',
  'global.allow_change_order_after_departure':
    'Allow change order after departure',
  'global.allow_change_order_before_departure':
    'Allow change order before departure',
  'global.tax_rate': 'Tax rate',
  'global.staff': 'Agent accounts',
  'global.payment': 'Payment Operator',
  'global.phone_code': 'Phone code',
  'validate.is_not_email': 'Field is not email',
  'validate.is_not_phone_number': 'Field is not phone number',
  'global.notify_url': 'Notify URL',
  'global.error_url': 'Error URL',
  'global.success_url': 'Success URL',
  'global.client_id': 'Client Id',
  'global.site': 'Site',
  //setting operator
  'global.operator': 'Operator',
  'global.show': 'Show',
  //routes
  'global.routes': 'Routes',
  'global.point': 'Point',
  'global.roles': 'Roles',

  //modal cashier info
  'global.cashier_info': 'Caisse',

  'global.liste': 'Liste',
  'global.last_sale': 'Dernier billet',
  'global.cashier_information': 'Historique',
  'global.cashier_detail': 'Reçu de versement',
  'global.route_name': 'Trajet',
  'global.depart_time': 'Departure Time',
  'global.arrival_time': 'Arrival Time',
  'global.bus_type': 'Bus type',
  'global.bus': 'Bus',
  'global.route_code': 'Route and Code',
  'global.current_price': 'Current price',

  'global.email_not_valid': 'Email is not valid',
  //bus order
  'orders.total': 'Total',
  'global.order_no': 'Order no',
  'orders.order_status': 'Order status',
  'orders.start_date': 'Start date',
  'orders.created': 'Created at',
  'global.one_way': 'One way',
  'global.two_way': 'Two way',
  'global.customers': 'Customers',
  'order.create': 'Create booking',
  'global.departure': 'Departure',
  'global.return': 'Return',
  'global.pay_method': 'Payment method',
  'global.update_status': 'Update status',
  'global.edit_status': 'Edit status',
  'global.send_to_sms': 'Send to SMS',
  'global.print': 'Print',

  //operator
  'global.company_info': 'Company Information',
  'global.booking_settings': 'Booking Settings',

  //Customers:
  'global.customers': 'Customers',
  'global.fullname': 'Full name',
  'global.userId': 'User ID',
  'global.company_name': 'Company name',
  'global.company_shortname': 'Short name',
  'global.company_tax_id': 'Tax code',
  'global.address': 'Address',
  'customer.create': 'Create',
  'global.orderId': 'Booking ID',
  'global.sell_by': 'Sell by',
  'order.tour_title': 'Tour title',
  'order.route_title': 'Title',
  'order.pay_status': 'Pay status',
  'order.order_status': 'Booking status',
  'order.voucher_status': 'Voucher status',
  'order.vat_status': 'VAT status',

  'global.email_mobile_required': 'Email or Mobile is requied',
  'global.password_required': 'Password is requied',

  'order.booking_time': 'Booking time',
  'order.reseller': 'Reseller',
  'order.rebook': 'Réservation',

  'global.role': 'Rôle',
  'global.add': 'Créer',
  'global.route_markets': 'Canaux de vente',
  // 'global.edit': 'Sửa',
  'global.password': 'Mot de passe',
  'global.resetpassword': 'Réinitialiser le mot de passe',
  'global.input_password': 'Entrez le mot de passe',
  'global.is_verified_email': "Vérifier l'email",
  'global.collaborator': 'Collaborateur',
  'global.is_mobile_verified': 'Vérifier le téléphone',
  'global.operator_user': 'Utilisateur Compagnie',
  'global.unverified': 'Non vérifié',
  'global.store': 'Magasin',
  'global.verified': 'Vérifié',
  'global.status': 'Statut',
  'global.add_price': 'Ajouter un départ',
  'global.add_new': 'Créer nouveau',
  'global.published': 'Publié',
  'global.unpublished': 'Non publié',
  'global.delete': 'Supprimer',
  'global.copy': 'Copier',
  'global.create': 'Ajouter',
  'global.update': 'Mettre à jour',
  'global.image': 'Image',
  'global.image_alt': "Texte alternatif de l'image",
  'global.schema_type': 'Type de schéma',
  'global.title': 'Titre',
  'global.slug': 'Slug',
  'global.sub_title': 'Sous-titre',
  'global.company': 'Compagnie',
  'global.id': 'ID',
  'global.tabbasic': 'Basique',
  'global.alias': 'Alias',
  'global.description': 'Description',
  'global.cancel': 'Annuler',
  'global.active': 'Actif',
  'global.deactivate': 'Inactif',
  'global.submit': 'Soumettre',
  'global.edit': 'Modifier',
  'global.trashed': 'Corbeille',
  'global.approved': 'Approuvé',
  'global.approve': 'Approuver',
  'global.from': 'Départ',
  'global.to': 'Arrivée',
  'global.price_discount': 'Prix réduit',
  'global.price_roundtrip': 'Prix aller-retour',
  'global.price': 'Prix',
  'global.infant_price': 'Prix bébé',
  'global.car': 'Voiture',
  'global.type': 'Type',
  'global.rating': 'Note',
  'global.room_rate': 'Tarif chambre',
  'global.cancel_policy': "Politique d'annulation",
  'global.instant_bookable': 'Réservation instantanée',
  'global.yes': 'Oui',
  'global.no': 'Non',
  'global.city': 'Compagnie',
  'global.street': 'Rue',
  'global.neighbourhood_cleansed': ' Quartier nettoyé',
  'global.neighbourhood_group_cleansed': ' Groupe nettoyé',
  'global.location': 'Emplacement',
  'global.choose-location': "Choisir l'emplacement",
  'global.square_feet': 'Pieds carrés',
  'global.bedrooms': 'Chambres',
  'global.bathrooms': 'Salles de bain',
  'global.beds': 'Lits',
  'global.bed_type': 'Type de lit',
  'global.cover_img': 'Image de couverture',
  'global.gallery': 'Galerie',
  'global.gallerySetting': 'Paramètres de la galerie',
  'global.security_deposit': 'Dépôt de garantie',
  'global.guests_included': 'Invités inclus',
  'global.minimum_nights': 'Nuits minimum',
  'global.cleaning_fee': 'Frais de nettoyage',
  'global.extra_people': 'Personnes supplémentaires',
  'global.maximum_nights': 'Nuits maximum',
  'global.months': 'Mois',
  'global.calendar': 'Calendrier',
  'global.province': 'Province',
  'global.district': 'District',
  'global.ward': 'Arrondissement',
  'global.no_house': 'Numéro de maison',
  'global.nearbyUtils': 'Utilitaires à proximité',
  'global.extra_price': 'Prix supplémentaire',
  'global.patients': 'Patients',
  'global.setting': 'Paramètre',
  'global.appointments': 'Rendez-vous',
  'global.suppliers': 'Fournisseurs',
  'global.id_number': "Numéro d'identification",
  'global.code': 'Code',
  'global.name': 'Nom',
  'global.services': 'Services',
  'global.clinic': 'Clinique',
  'global.website': 'Site web',
  'global.contact_name': 'Contact',
  'global.refresh': 'Actualiser',
  'global.distance': 'Distance',
  'global.update_success': 'Mise à jour réussie !',

  'car.driver': 'Chauffeur',
  'car.seat': 'Siège',
  'car.luggage': 'Bagages',
  'car.ordering': 'Réservation',
  'car.facility': 'Équipement',
  'car.air_machine': 'Climatisation',
  'car.energy_saving': "Économie d'énergie",
  'car.stop_point': 'Arrêt',
  'property.start_date': 'Date de début',
  'property.end_date': 'Date de fin',
  'property.price_week': 'Prix semaine',
  'property.weekend_price': 'Prix weekend',
  'property.extra_price': 'Prix supplémentaire',
  'property.host_languages': " Langues de l'hôte",
  'property.week_term_promo': 'Promotion semaine',
  'property.month_term_promo': 'Promotion mois',
  'property.price_weekend': 'Prix weekend',
  'global.guests_standard': 'Invités standard',
  'global.guests_max': 'Invités max',
  'sidebar.transport': 'Transport',
  'sidebar.amenity': 'Commodité',
  'sidebar.restaurant': 'Restaurant',
  'sidebar.property': 'Propriété',
  'sidebar.property_type': 'Type de propriété',
  'sidebar.room': 'Chambre',
  'sidebar.cancel_policy': "Politique d'annulation",
  'sidebar.vehicle': 'Véhicule',
  'sidebar.car': 'Voiture',
  'sidebar.route': 'Itinéraire',
  'sidebar.routes': 'Routes',
  'sidebar.inbox': 'Boîte de réception',
  'sidebar.conversation': 'Conversation',
  'sidebar.reservations': 'Réservations',
  'sidebar.earning': 'Gains',
  'sidebar.calendar': 'Ajouter prix',
  'sidebar.reports': 'Rapports',
  'sidebar.services': 'Services',
  'sidebar.addons_order': 'Services supplémentaires',
  'sidebar.debt_confirmation_record': 'Enregistrement de confirmation de dette',
  'global.requiredfield': 'Champ obligatoire',
  'global.numberfield': 'Le champ doit être un nombre',
  'global.nombre': 'Nombre',

  'property.room_type': 'Type de chambre',
  'global.propertytypes': 'Type de propriété',
  'global.save': 'Enregistrer',
  'global.save_and_close': 'Ajouter et fermer',
  'global.signin': 'Se connecter',
  'global.signup': "S'inscrire",
  'global.forgot_password': 'Mot de passe oublié',
  'global.search_placeholder': 'Rechercher',

  'global.sms_settings': 'Notifications',
  'global.app_settings': 'Applications',

  'global.disabled': 'Désactivé',
  'global.enabled': 'Activé',

  //sms settings
  'global.sender_id': "ID de l'expéditeur",
  'global.user_app': 'Application utilisateur',
  'global.operator_app': 'Application Compagnie',

  //user app settings
  'global.app_listing': 'Liste des applications',
  'global.app_status': "Statut de l'application",
  'global.booking_message': 'Message de réservation',
  'global.booking': 'Réservation',
  'global.selling_start': 'Début de vente',
  'global.any_time': 'À tout moment',
  'global.custom': 'Personnalisé',

  //Tour
  'global.duration': 'Durée',
  'global.routes': 'Routes',
  'global.category': 'Catégorie',
  'global.cover_image': 'Couverture',
  'global.url': "URL de l'image",
  'global.operator': 'Compagnie',
  'global.from_price': 'Prix',
  'global.itinerary': 'Itinéraire',
  'global.itineraries': 'routes',
  'global.updated_at': 'Mis à jour le',
  'global.from_priceMGMT': 'Prix',
  'global.from_price_setting': ' Paramètres de prix',
  'global.tours': 'Visites',
  'global.transportation': 'Transport',
  'global.score': 'Score',
  'global.tour_option': 'Options de visite',
  'global.hourly': 'Horaire',
  'tour.title': 'Titre',
  'global.select_category': 'Sélectionner la catégorie',
  'global.select_operator': "Sélectionner l'Compagnie",
  'global.select_cabin_type': 'Sélectionner le type de cabine',
  'tour.description': 'Description de la visite',
  'tour.inclusion': 'Inclusion',
  'tour.exclusion': 'Exclusion',
  'global.inactive': 'Inactif',
  'global.meal': 'Repas',
  'global.category_operator': 'Catégorie et Compagnie',
  'tour.pricing': 'Modèle de tarification',
  'tour.special': 'Spécial',
  'tour.normal': 'Normal',
  'tour.featured': 'En vedette',
  'tour.time_mgmt': 'Gestion du temps',
  'tour.duration_unit': 'Unité de durée',
  'tour.duration': 'Durée',
  'tour.start_time': 'Départ',
  'tour.instant_confirm': 'Confirmation instantanée',
  'global.delete_confirm': 'Êtes-vous sûr de vouloir supprimer cet élément ?',
  'global.cancel_order': 'Êtes-vous sûr de vouloir annuler cet élément ?',
  'tour.gallery': 'Galerie',
  'global.ticket': 'Billet',
  'global.display': 'Affichage',
  'global.min_person': 'Personne minimum',
  'global.freeCancelHours': "Heures d'annulation gratuite",
  'global.freeCancel': 'Annulation gratuite',
  'tour.freeCancel': 'Annulation gratuite',
  'global.cancelPolicy': "Politique d'annulation",
  'global.meeting': 'Point de rencontre',
  'global.meetingPoint': 'Point de rencontre',
  'global.meeting_point': 'Point de rencontre',
  'global.meeting_point_type': 'Type de point de rencontre',
  'global.meetingPointNotes': 'Notes du point de rencontre',
  'tour.cutOffTime': 'Heure limite (heures)',
  'tooltip.cutOffTime':
    'Par exemple : 2 jours avant la date de départ équivaut à 48 heures',
  'global.perPerson': 'Par personne',
  'global.perGroup': 'Par groupe',
  'global.optionTitle': "Titre de l'option",
  'global.checkall': 'Tout cocher',

  'global.show_seat_map': 'Afficher le bus',

  //trajet
  'global.trajet': 'Trajet',
  'global.lieu_arrivee': "Lieu d'arrivée",
  'global.heure_ramassage': 'Heure de prise en charge',
  'global.heure': 'Heure',
  'global.lieu_depart': 'Lieu de départ',
  'global.depart': 'Départ',
  'global.arrivee': 'Arrivée',
  'global.prix': 'Prix',
  'global.sous_trajet_id': 'Id du sous-trajet',
  'global.code_trajet': 'Code du trajet',
  'global.policy': 'Politique',
  'global.app_id': "ID de l'application",

  'global.collaborators': 'Collaborateurs',

  //Seatmap
  'global.chosen': 'Choisi',
  'global.taken': 'Pris',
  'global.locked': 'Verrouillé',
  'global.free': 'Libre',

  //Option
  'global.max_person': 'Personne maximum',
  'global.max': 'Max',
  'global.adult_price': 'Prix adulte',
  'global.child_price': 'Prix enfant',
  'global.cost_price': 'Prix coûtant',
  'global.cost': 'Coût',
  'global.selling_price': 'Prix de vente',
  'global.selling': 'Vente',
  'global.cost_price_notes': 'Notes du prix coûtant',
  'global.select_tour': 'Sélectionner la visite',
  'global.option': 'Option',
  'global.options': 'Options',
  'option.group': 'Groupe',
  'global.Vehicle_type': 'Type de véhicule',
  'global.timeStart': 'Heure de début',
  'global.startWorkingTime': 'Heure de début de travail',
  '.endWorkingTime': 'Heure de fin de travail',

  //Destination
  'global.destination': 'Destination',
  'global.select_destination': 'Sélectionner la destination',
  'global.countries': 'Pays',
  'global.select_country': 'Sélectionner le pays',
  'destination.longitude': 'Longitude',
  'destination.latitude': 'Latitude',
  'global.destination_parent': 'Destination parent',

  //Categories
  'global.categories': 'Catégories',

  //Operators
  'global.operators': 'Compagnies',
  'global.firstname': 'Prénom',
  'global.lastname': 'Nom',
  'global.email': 'Email',
  'global.phone': 'Téléphone',
  'global.hotline': "Ligne d'assistance",
  'global.params': 'Paramètres',
  'global.limit_order_start_time': 'Heure limite de début de commande',
  'global.allow_change_order_after_departure_hour':
    "Autoriser la modification de la commande après l'heure de départ",
  'global.allow_change_order_after_departure':
    'Autoriser la modification de la commande après le départ',
  'global.allow_change_order_before_departure':
    'Autoriser la modification de la commande avant le départ',
  'global.tax_rate': 'Taux de taxe',

  //Currencies
  'global.currencies': 'Devise',
  'currency.name': 'Nom',
  'currency.display': 'Affichage',
  'currency.exchange_rate': 'Taux de change',
  'currency.thousand': 'Format',
  'currency.image': 'Icône',
  'currency.symbol': 'Symbole',
  //post
  'global.posts': 'Articles',
  'post.fulltext': 'Texte complet',
  'post.short': 'Court',
  'global.featured': 'En vedette',
  'post.hit': 'Vue',
  'post.metadesc': 'Meta description',
  'post.metakey': 'Meta key',
  'post.image': 'Image',

  //home
  'global.total_booking_today': 'Réservations',
  'global.total_segments': 'Segments',
  'global.total_revenue_today': 'Revenus',
  'global.total_seat_today': 'Sièges',
  //Log-in Log-out
  // 'global.account_information': 'Informations de compte',
  // 'global.signout': 'Se déconnecter',
  'global.email_required': 'Email requis',
  'global.password_required': 'Mot de passe requis',
  'global.email_not_valid': 'Email non valide',

  //Site:
  'global.site': 'Site',
  'sites.hotline': "Ligne d'assistance",
  'sites.locale': 'Langue',
  'sites.from_email': "Email de l'expéditeur",
  'sites.from_name': "Nom de l'expéditeur",
  'sites.currency': 'Devise',
  'sites.timezone': 'Fuseau horaire',
  'sites.meta_description': 'Meta description',
  'sites.meta_title': 'Meta title',
  'sites.email': 'Email',
  'global.sites': 'Sites',
  //Bookings:
  'global.order': 'Réservation',
  'global.orderId': 'ID de la réservation',
  'global.sell_by': 'Vendu par',
  'order.tour_title': 'Titre de la visite',
  'order.route_title': 'Titre',
  'order.pay_status': 'Statut du paiement',
  'order.order_status': 'Statut de la réservation',
  'order.voucher_status': 'Statut du bon',
  'order.vat_status': 'Statut de la TVA',
  'order.depart_date': 'Date de départ',
  'order.customer': 'Client',
  'order.totalTravelers': 'Nombre total de voyageurs',
  'order.totalPrice': 'Prix total',
  'order.created': 'Réservé le',
  'order.created_by': 'created_by',
  'order.create': 'Créer réservation',
  'order.order_seat': 'Attribution des sièges',
  'global.one_way': 'Aller simple',
  'global.two_way': 'Aller-retour',
  'global.time': 'Heure',
  'global.search': 'Rechercher',
  'global.departure': 'Départ',
  'global.return': 'Retour',
  'global.assign_operator': "Attribuer l'Compagnie",
  'global.assign': 'Attribuer',
  'global.total': 'Total',
  'global.group_code': 'Code',
  'global.update_status': 'Mettre à jour le statut',
  'order.depart/return': 'Départ / Retour',
  'global.cashier': 'Caissiers',
  'global.cashier_name': 'Caissier',
  //Customers:
  'global.customers': 'Clients',
  'global.fullname': 'Nom',
  'global.userId': "ID d'utilisateur",
  'global.company_name': "Nom de l'entreprise",
  'global.company_shortname': 'Nom abrégé',
  'global.company_tax_id': 'Numéro de taxe',
  'global.address': 'Adresse',
  'customer.create': 'Ajouter',

  //Orders
  'orders.start_date': 'Date de voyage',
  'orders.total': 'Total',
  'orders.order_status': 'Statut de la commande',
  'orders.created': 'Créé',
  'global.access': 'Accès',
  //Users:
  'global.roles': 'Roles',
  'global.users': 'Utilisateurs',

  //Schedule
  'global.schedule_setting': "Paramètres de l'horaire",
  'global.schedule': 'Horaire',
  'global.start_date': 'Date de voyage',
  'global.end_date': 'Date de fin',
  'global.weekdays': 'Jours de la semaine',

  'global.weekday': 'Jour de la semaine',
  'global.statistic': 'Statistique',
  'global.view_seat_map': 'Afficher le Plan du véhicule',
  'global.booked_seat': 'Siège réservé',
  'global.disabled_seats': 'Sièges désactivés',
  'global.preview_seat_map': 'Prévisualiser le Plan du véhicule',

  'global.disabled_seat': 'Désactiver le siège',
  'global.enable_seat': 'Activer le siège',
  //wishlist
  'global.wishlist': 'Liste de souhaits',
  'wishlist.tour_title': 'Titre de la visite',
  'wishlist.customer': 'Client',
  'global.basic': 'Basique',
  'global.item': 'Élément',
  'global.items': 'Éléments',
  'global.sku': 'SKU',
  'global.widgets': 'Widgets',
  'global.widget': 'Widget',

  //menus
  'global.menus': 'Menus',
  'global.menu': 'Menu',
  'global.key': 'Clé',
  'global.menu_items': 'Éléments de menu',
  'global.menu_item': 'Élément de menu',

  //Register
  'global.registration_header': "Formulaire d'inscription",
  'global.country': 'Pays',
  'global.mobile': 'Téléphone',
  'signup.back_to_login': 'Retour à la connexion',
  'global.continue': 'Continuer',
  'global.close': 'Fermer',
  'global.close_cashier': 'FERMER CAISSE',
  'global.bagages': 'Bagages',
  'global.first_bagage': 'Premier bagage',
  'global.last_bagage': 'Dernier bagage',

  //
  'global.statistics': 'Statistiques',
  'global.tour_rates': 'Tarifs',
  'global.tour_options': 'Options',
  'global.destinations': 'Destinations',
  'global.orders': 'Réservations',
  'global.reviews': 'Avis',

  'global.language': 'Langue',
  'global.currency': 'Devise',
  'global.your_plan': 'Forfait',
  'global.trial_end': "Date d'expiration",
  'global.timezone': 'Fuseau horaire',
  'global.emai_required': 'Email requis',
  // 'global.password_required': 'Yêu cầu điền mật khẩu',
  'global.emai_not_valid': 'Email non valide',
  'global.confirm_password': 'Confirmer le mot de passe',

  'global.confirm_new_password': 'Confirmer le nouveau mot de passe',
  'global.new_password': 'Nouveau mot de passe',
  'global.current_password': 'Mot de passe actuel',
  'global.password_not_match': 'Les mots de passe ne correspondent pas',
  'global.password_min_charactor': '6 caractères minimum',
  'global.home': 'Accueil',

  'global.please_select_start_and_stop_destination':
    "Veuillez sélectionner les destinations de départ et d'arrivée",

  // Cabins
  'global.cabins': 'Cabines',
  'global.size': 'Taille',
  'global.qty': 'Quantité',
  'global.route': 'Trajet',

  // Customer Groups
  'global.discount': 'Remise',
  'global.cGroups': 'Groupes de clients',
  'global.group': 'Groupe',

  //
  'global.hops': 'Étapes',
  'global.systems': 'Systèmes',
  'global.start_time': 'Heure de début',
  'global.start_stop': 'Destination de départ',
  'global.end_stop': "Destination d'arrivée",
  'global.cabin-rates': 'Tarifs des cabines',
  'global.title_route': 'Itinéraire',

  // Addons
  'global.addons': 'Services supplémentaires',
  'global.seat': 'Siège',
  'global.from_date': 'Du',
  'global.to_date': 'Au',

  'global.order_group': 'Groupe de réservation',
  'global.route_tital': 'Itinéraire',
  'global.select_customer': 'Passagers',
  'global.select_option': "Sélectionner l'option",
  'global.order_status': 'Statut de la réservation',
  'global.pay_method': 'Mode de paiement',
  'global.order_cancel': 'Êtes-vous sûr de vouloir annuler cette commande ?',
  'order.pax': 'Passagers',
  'global.passport': 'Passeport',
  'global.addnew': 'Ajouter',
  'global.select_county': 'Sélectionner le comté',
  'global.cabin': 'Cabine',
  'global.price_type': 'Type de prix',
  'global.voucher': 'Bon',
  'global.passengers': 'Passagers',
  'global.notes': 'Notes',
  'global.order_id': 'ID de la réservation',
  'global.select_date': 'Sélectionner la date',
  'global.select_hops': "Sélectionner l'étape",
  'global.pay_status': 'Statut du paiement',
  'bill.serial': 'Numéro de série',
  'bill.billed_date': 'Date de facturation',
  'bill.amount': 'Montant',
  'global.method': 'Paiement',
  'global.wave_template_sms': 'Modèle SMS Wave',
  'global.suffix_userapp': 'Suffixe application utilisateur',
  'global.suffix_operatorapp': 'Suffixe application Compagnie',
  'global.is_on_operatorapp': 'Application Compagnie',
  'global.is_on_userapp': 'Application utilisateur',
  'global.fee': 'Frais',
  'global.fee_default': 'Frais par défaut',
  'global.field': 'Champ',
  'global.payment_method': 'Mode de paiement',
  'global.op_payment_method': "Mode de paiement de l'Compagnie",
  'global.seat_lock': 'Verrouillage du siège',
  'global.session': 'Session',
  'global.bills': 'Paiements',
  'global.notpaid': 'Non payé',
  'global.paid': 'Payé',
  'global.collect': 'Collecter',
  'global.spend': 'Dépenser',
  'global.cash': 'Espèces',
  'global.card': 'Carte',
  'global.bank': 'Banque',
  'global.insurance': 'Assurance',
  'global.select_customers': 'Passagers',
  'global.select_types': 'Sélectionner le type',
  'sidebar.dept': 'AR',
  'global.total_debt_begin_period': 'Dette début de période',
  'global.total_paid_begin_period': 'Payé début de période',
  'global.total_debt_in_period': 'Dette dans la période',
  'global.total_paid_in_period': 'Payé dans la période',
  'global.total_debt_end_period': 'Dette totale',

  'global.ar': 'Comptes clients',
  'global.confirm': 'Confirmer',
  'global.order_confirm': 'Êtes-vous sûr de vouloir confirmer cette commande ?',
  'global.bill_confirm': 'Êtes-vous sûr de vouloir approuver cette facture ?',
  // 'global.cabin_rates': 'Cabin rates',
  'global.bookingCalendar': 'Calendrier de réservation',
  'global.invoice': 'Facture',
  'global.list_order_not_paid': 'Liste des commandes non payées',
  'global.export_to_excel': 'Exporter vers Excel',
  'global.report_debt_confirmation': 'Enregistrement de confirmation de dette',
  'global.debt': 'Dossiers AR',
  'global.bill': 'Paiement',
  'global.record': 'Enregistrement',
  // report
  'global.date': 'Date',
  'global.hop': 'Étape',
  'global.addon': 'Service supplémentaire',
  'global.customer': 'Client',
  'global.year': 'Année',

  'global.select_menu': 'Sélectionner le menu',
  'global.select_role': 'Sélectionner le rôle',

  'global.add_walk_in_customer': 'Ajouter un client sans rendez-vous',
  'global.order_details': 'Détails de la réservation',
  'global.cabins_order': 'Commande des cabines',
  'global.last_30_day': '30 derniers jours',
  'global.last_7_day': '7 derniers jours',
  'global.last_month': 'Mois dernier',
  'global.this_month': 'Ce mois-ci',
  'global.next_month': 'Mois prochain',
  'global.seller': 'Vendeur',
  'global.send_email': 'Envoyer un email',
  'global.sale': 'Vente',
  'global.finance': 'Finances',
  'global.carriages': 'Voitures',
  'global.logo': 'Logo',
  'global.content': 'Contenu',
  'global.path': 'Chemin',
  'global.seat_allocation': 'Attribution des sièges',
  'global.cabinSerials': 'Numéros de série des cabines',
  'global.title_carriage': 'Titre de la voiture',
  'global.title_cabin': 'Titre de la cabine',
  'global.select_carriage': 'Sélectionner la voiture',
  'global.order_seat': 'Réserver un siège',
  'global.order_seats': 'Réserver des sièges',
  'global.Seat': 'Siège',
  'global.lock': 'Verrouiller',
  'global.expiration': 'Expiration',
  'global.depart_seating': 'Sièges de départ',
  'global.return_seating': 'Sièges de retour',
  'global.seating': 'Sièges',
  'global.gateway_url': 'URL de la passerelle',
  'global.summary': 'Résumé',
  'global.action': 'Action',
  'global.created_at': 'Créé le',
  'global.created_by': 'Créé par',
  'global.roundtrip': 'Aller-retour',

  'sites.url': 'URL',
  'sites.ga_script': 'Script Google Analytics',
  'global.meta_data': 'Meta Data',
  'global.meta_title': 'Meta titre',
  'global.meta_description': 'Meta Description',
  'global.meta_keywords': 'Meta Keywords',
  'global.before_head': "Avant l'en-tête",
  'global.before_body': 'Avant le corps',
  'global.layout': 'Disposition',
  'global.socials': 'Réseaux sociaux',

  // status
  'global.all': 'Tous',
  'global.pending': 'En attente',
  'global.confirmed': 'Confirmé',
  'global.cancelled': 'Annulé',
  'global.refund': 'Remboursement',
  'global.mark_as_paid': 'Marquer comme payé',

  'global.super': 'Super',
  'global.admin': 'Admin',
  'global.staff': 'Personnel',
  'global.agent': 'Agent',
  'global.upgrade': 'Mettre à niveau',
  'global.cabin_no': 'Numéro de cabine',
  'global.carriage': 'Voiture',
  'global.cabin_type': 'Type de cabine',
  'global.view_seat': 'Voir le siège',
  'global.view': 'Voir',
  'global.ok': 'Ok',
  'global.seats': 'Sièges',
  'global.time_period': 'Période',
  'global.booked_seats': 'Sièges réservés',
  'global.allocated_seat': 'Siège attribué',
  'global.revenue': 'Revenu',
  'global.revenue_report': 'Rapport des revenus',
  'global.cabins_performance': 'Performance des cabines',
  'global.created_date': 'Date de création',
  'global.depart_date': 'Date de départ',
  'global.download': 'Télécharger',
  'global.permission': 'Autorisation',
  'global.permissions': 'Autorisations',
  'permissions.decline': 'Refuser',
  'permissions.allow': 'Autoriser',
  'global.e_ticket': 'Billet électronique',
  'global.internal_notes': 'Notes internes',
  'global.information_customer': 'Informations client',
  'global.cgroup': 'Groupe de clients',
  'global.order_information': 'Informations sur la réservation',
  'global.accountant_email': 'Email du comptable',
  'global.more': 'plus',
  'global.full': 'Complet',
  'global.deposited': 'Déposé',
  'global.payment_type': 'Type de paiement',
  'global.payment_status': 'Statut du paiement',
  'global.contact_information': 'Coordonnées',
  'global.contacts': 'Contacts',
  'global.contact': 'Contact',
  'global.add_contact': 'Ajouter un contact',
  'global.office': 'Bureau',
  'global.select_contact': 'Sélectionner le contact',
  'global.select_seller': 'Sélectionner le vendeur',
  'global.input_group_code': 'Entrez le code',
  'global.input_pax': 'Entrez les passagers',
  'global.input_order_notes': 'Entrez les notes de commande',
  'global.input_order_internal_notes': 'Entrez les notes internes',
  'global.input_contact_name': 'Entrez le nom du contact',
  'global.input_contact_email': "Entrez l'email du contact",
  'global.input_contact_mobile': 'Entrez le mobile du contact',
  'validate.is_not_email': "Le champ n'est pas un email",
  'validate.is_not_phone_number': "Le champ n'est pas un numéro de téléphone",
  'order.select_other_contact': 'Autre',
  'global.select_hop': 'Sélectionner une étape',
  'global.select_route': 'Sélectionner un itinéraire',
  'global.book': 'Réserver',
  'global.user': 'Utilisateur',
  'global.save_success': 'Enregistrement réussi',
  'global.save_failed': "Échec de l'enregistrement",
  'global.guide_number': 'Guide',
  'global.input_guide_number': 'Entrez le guide',
  'global.input_your_password': 'Veuillez entrer votre mot de passe !',
  'global.input_beds': 'Veuillez entrer le nom des lits ou supprimer ce champ',
  'global.input_email_or_delete':
    "Veuillez entrer le nom de l'e-mail ou supprimer ce champ",
  'global.select_destination_start': 'Sélectionner la destination de départ',
  'global.select_destination_end': "Sélectionner la destination d'arrivée",
  'placeholder.select_hop': "Sélectionner l'étape",
  'placeholder.select_addon': 'Sélectionner un service supplémentaire',
  'placeholder.from': 'De',
  'placeholder.to': 'À',
  'placeholder.select_category': 'Sélectionner la catégorie',
  'placeholder.select_customer_group': 'Sélectionner le groupe de clients',
  'global.select_user': "Sélectionner l'utilisateur",
  'placeholder.select_user': "Sélectionner l'utilisateur",
  'global.select_permission': "Sélectionner l'autorisation",
  'global.select_all': 'Tout sélectionner',
  'global.advanced_settings_for_each_user':
    'Paramètres avancés pour chaque utilisateur',
  'note.reload_page':
    'Vous devez recharger la page après avoir terminé la modification',
  'global.history': 'Historique',
  'global.clear': 'Effacer',
  'history.from_date': 'De',
  'history.to_date': 'À',
  'history.week_days': 'Jours de la semaine',
  'global.reload': 'Recharger',
  'global.clear_rate_confirm': 'Êtes-vous sûr de vouloir effacer ces données ?',
  'placeholder.booking_id_or_code': 'ID de réservation ou code',
  'global.special_notes': 'Notes spéciales',
  'placeholder.input_special_notes': 'Entrez les notes spéciales',
  'global.choice_a_time_period': 'Choisir une période',
  'global.not_found': 'Introuvable',
  'global.select_a_customer': 'Sélectionner un client',
  'placeholder.select_customer': 'Passagers',
  'placeholder.input_notes': 'Entrez les notes',
  'placeholder.input_description': 'Entrez la description',
  'placeholder.select_creator': 'Sélectionner le créateur',
  'placeholder.select_status': 'Sélectionner le statut',
  'placeholder.select_status_order': 'Statut de la réservation',
  'placeholder.payment_from': 'Paiement de',
  'placeholder.payment_to': 'Paiement à',
  'global.initialization_time': "Temps d'initialisation",
  'placeholder.input_title': 'Entrez le titre',
  'placeholder.input_code': 'Entrez le code',
  'placeholder.select_route': "Sélectionner l'itinéraire",
  'error.quantity_is_not_the_same':
    "La quantité n'est pas la même que la quantité commandée",
  'global.addons_booking': 'Services supplémentaires',
  'error.missing_addon': 'Veuillez sélectionner un service supplémentaire',
  'warning.not_found_carriages': 'Aucune voiture disponible',
  'global.individual': 'Individuel',
  'global.available': 'Disponible',
  // 'global.booking_statistics': 'Statistiques des réservations',
  'global.total_number_of_tickets': 'Nombre total de billets',
  'global.sold': 'Vendu',
  'global.remaining': 'Restant',
  'global.capacity': 'Capacité',
  'global.general_capacity': 'Capacité générale',
  'global.files_manager': 'Gestionnaire de fichiers',
  'error.upload_file':
    'Erreur lors du téléchargement du fichier. Veuillez réessayer.',
  'success.upload_file': 'Fichier téléchargé avec succès !',
  'global.create_folder': 'Ajouter un dossier',
  'placeholder.input_folder_name': 'Entrez le nom du dossier',
  'global.folder_name': 'Nom du dossier',
  'error.create_folder':
    'Erreur lors de la création du dossier. Veuillez réessayer.',
  'error.delete_file': 'Erreur de suppression, veuillez réessayer.',
  'error.folder_name': 'Nom de dossier non valide, veuillez réessayer.',
  'error.missing_file_upload':
    'Veuillez sélectionner un fichier à télécharger.',
  'placeholder.select_date': 'Sélectionner la date',
  'placeholder.input_email': "Entrez l'email",
  'global.send': 'Envoyer',
  'global.download_addon_booking': 'Télécharger les services supplémentaires',
  'error.send_email': "Erreur lors de l'envoi de l'email. Veuillez réessayer.",
  'global.send_email_success': 'Email envoyé avec succès',
  'global.customer_name': 'Nom du client',
  'global.seated_by': 'Placé par',
  'global.seated_date': 'Date de placement',
  'sidebar.invoice': 'Facture',
  'global.booked_from': 'Réservé de',
  'global.booked_to': 'Réservé à',
  'global.amount_of_money': "Montant d'argent",
  'global.track': 'Suivi',
  'placeholder.input_track': 'Entrez le suivi',
  'global.amenities': 'Équipements',
  'global.icon': 'Icône',
  'error.must_contain_least_one_value':
    'Doit contenir au moins une information sur le passager',
  'global.representative_passenger': 'Passager représentant',
  'placeholder.input_firstname': 'Entrez le prénom',
  'placeholder.input_lastname': 'Entrez le nom de famille',
  'error.missing_passenger_information':
    'Veuillez entrer au moins une information sur le passager',
  'global.refund_policy': 'Politiques de remboursement',
  'global.refund_policies': 'Politiques de remboursement',
  'global.cancel_fee': "Frais d'annulation",
  'global.hours': 'Heures',
  'global.is_default': 'Est par défaut',
  'global.select_tours': 'Sélectionner une visite',
  'global.payments': 'Paiements',
  'global.payment_date': 'Date de paiement',
  'global.payment': 'Paiement',
  'global.refund_recording': 'Enregistrement du remboursement',
  'global.transaction': 'Transaction',
  'global.transactions': 'Transactions',
  'global.penalty_date': 'Date de pénalité',
  'global.today': "Aujourd'hui",
  'global.penalty_status': 'Statut de la pénalité',
  'global.no_payment_yet': 'Aucun paiement pour le moment',
  'global.tour': 'Visite',
  'placeholder.input_amount': 'Entrez le montant',
  'success.refund_recorded': 'Remboursement enregistré',
  'global.adults': 'Adultes',
  'global.children': 'Enfants',
  'global.infants': 'Bébés',
  'global.pickup_location': 'Lieu de prise en charge',
  'global.income': 'Revenu',
  'global.expense': 'Dépense',
  'global.pay': 'Payer',
  'global.debit': 'Débit',
  'global.amount': 'Montant',
  'global.transaction_date': 'Date de la transaction',
  'global.guest_payment_date': 'Date de la transaction',
  'global.policy_penalty_name': 'Nom de la politique de pénalité',
  'global.guest_payment': 'Transaction',
  'global.guest_payment_detail': 'Détail de la transaction',
  'global.waiting_approve': "En attente d'approbation",
  'global.created_payments': 'Paiements créés',
  'tour.pickup_offered': 'Prise en charge proposée',
  'global.pickup_offer': 'Offre de prise en charge',
  'global.both': 'Les deux',
  'global.free_cancel': 'Annulation gratuite',
  'global.penalty': 'Pénalité',
  'global.cancel_booking': 'Annuler la réservation',
  'global.pickup_time': 'Heure de prise en charge',
  'global.create_transaction': 'Ajouter une transaction',
  'global.depart_value': 'Valeur de départ',
  'global.penalty_amount': 'Montant de la pénalité',
  'global.add_pickup': 'Ajouter une prise en charge',
  'global.select_meeting_type': 'Sélectionner le type de point de rencontre',
  'global.book_tour': 'Réserver une visite : ',
  'global.endWorkingTime': 'Heure de fin de travail',

  //payment method
  'global.merchant_id': 'ID du commerçant',
  'global.secret_key': 'Clé secrète',
  'global.notify_url': 'URL de notification',
  'global.identifiant': 'Identifiant',
  'global.error_url': "URL d'erreur",
  'global.success_url': 'URL de succès',
  'global.client_id': 'ID du client',
  'global.merchant_account': 'Compte marchand',
  'global.client_secret': 'Secret client',
  'global.yobuma': 'Yobuma',
  'global.markets': 'Marchés',

  //
  'global.send_link_payment': 'Envoyer le lien de paiement',
  'global.filter_params': 'Filtres',
  'global.category_id': 'Catégorie',
  'global.destination_id': 'Destination',

  'global.market': 'Marché',
  'global.flat': 'Forfait',
  'global.commission_amount': 'Montant de la commission',

  'global.waiting': 'En attente',

  'global.select_operators': 'Sélectionner les Compagnies',
  'order.supplier_status': 'Statut du fournisseur',
  'global.free_cancel_date': "Date d'annulation gratuite",
  'global.time_start': 'Heure de début',
  'global.supplier_total': 'Total fournisseur',
  'global.edit_pickup': 'Modifier la prise en charge',

  'global.drop_off': 'Dépose',
  'global.driver_notes': 'Notes du chauffeur',
  'global.policies': 'Politiques',
  'global.cancellation_policy_summary': 'Annulation',
  'global.service_fee': 'Frais de service',
  'global.ordering': 'Commande',
  'global.price_cron': 'Cron de prix',
  'global.unit': 'Unité',

  'global.subtotal': 'Sous-total',
  'global.refund_amount': 'Montant du remboursement',
  'global.cancellation_date': "Date d'annulation",
  'global.cancellation_fee': "Frais d'annulation",
  'global.cache_reset': 'Réinitialisation du cache',
  'global.additional_info': 'Informations supplémentaires',
  'global.driver': 'Chauffeur',

  'global.select_type': 'Sélectionner le type',
  'global.brand': 'Marque',

  // crm
  'global.crm': 'CRM',
  'global.segments': 'Segments',
  'global.templates': 'Modèles',
  'global.campaigns': 'Campagnes',
  'global.phone_code': 'Code téléphonique',
  'global.action_date': "Date d'action",
  'global.date_of_birth': 'Date de naissance',
  'global.lead_status': 'Statut du prospect',
  'global.new': 'Nouveau',
  'global.open': 'Ouvert',
  'global.in_progress': 'En cours',
  'global.unqualified': 'Non qualifié',
  'global.attempted_to_contact': 'Tentative de contact',
  'global.connected': 'Connecté',
  'global.bad_timing': 'Mauvais timing',
  'global.subscribed': 'Abonné',
  'global.unsubscribed': 'Désabonné',
  'global.owner': 'Propriétaire',
  'global.subject': 'Sujet',
  'global.once': 'Une fois',
  'global.daily': 'Quotidien',
  'global.repeat': 'Répéter',
  'global.audiences': 'Audiences',
  'global.analytics': 'Analytique',
  'global.opened': 'Ouvert',
  'global.schedule_date': 'Date prévue',
  'global.send_now': 'Envoyer maintenant',
  'global.campaign_key': 'Clé de campagne',
  'global.segment': 'Segment',
  'global.template': 'Modèle',
  'global.links': 'Liens',
  'global.conditions': 'Conditions',
  'global.is': 'Est',
  'global.is_not': "N'est pas",
  'global.contain': 'Contient',
  'global.not_contain': 'Ne contient pas',
  'global.start_with': 'Commence par',
  'global.end_with': 'Se termine par',
  'global.send_index': 'Envoyer IndexNow',
  'global.send_success': 'Message envoyé',
  'global.send_failed': 'Message non envoyé',
  'global.source': 'Source',
  'global.apply': 'Appliquer',
  'global.sent': 'Envoyé',
  'global.not_send': 'Non envoyé',
  'global.sent_date': "Date d'envoi",
  'global.recipients': 'Destinataires',
  'global.campaign_status': 'Statut de la campagne',
  'global.running': 'En cours',
  'global.stopped': 'Arrêtée',
  'global.create_segment': 'Ajouter un segment',
  'global.clicked': 'Cliqué',
  'global.start': 'Démarrer',
  'global.stop': 'Arrêter',
  'global.completed': 'Terminé',
  'global.not_open': 'Non ouvert',
  'global.not_click': 'Pas de clic',
  'global.promotions': 'Promotions',
  'global.promotion': 'Promotion',
  'global.used_from': 'Utilisé de',
  'global.used_to': 'Utilisé à',
  'global.used_at': 'Utilisé le',
  'global.discounts': 'Réductions',
  'placeholder.select_group': 'Sélectionner le groupe',
  'global.customer_group': 'Groupe de clients',
  'global.booked_at_from': 'Réservé de',
  'global.booked_at_to': 'Réservé à',
  'placeholder.booked_at_from': 'Réservé de',
  'placeholder.booked_at_to': 'Réservé à',
  'placeholder.used_at_from': 'Utilisé de',
  'placeholder.used_at_to': 'Utilisé à',
  'global.booked_at': 'Réservé le',

  // ROUTE CONFIGURATION
  'global.route_config': "Configuration de l'itinéraire",
  'global.seat_map': 'Plan du véhicule',
  'global.row': 'Rangée',
  'global.column': 'Colonne',
  'global.vehicles': 'Véhicules',
  'global.short_name': 'Nom abrégé',
  'global.user_id': "ID d'utilisateur",
  'placeholder.select_operator': "Sélectionner l'Compagnie",
  'global.serial': 'Numéro de série',
  'placeholder.select_seat_map': 'Sélectionner le Plan du véhicule',
  'global.preview_seat_map': 'Prévisualiser le Plan du véhicule',
  'global.start_location': 'Lieu de départ',
  'global.end_location': "Lieu d'arrivée",
  'global.end_time': 'Heure de fin',
  'global.vehicle': 'Véhicule',
  'placeholder.select_vehicle': 'Sélectionner le véhicule',
  'placeholder.select_start_location': 'Sélectionner le lieu de départ',
  'placeholder.select_end_location': "Sélectionner le lieu d'arrivée",
  'global.destination_map': 'Carte de destination',
  'global.segment_title': 'Titre du segment',
  'global.add_segment': 'Ajouter un segment',
  'global.payment-method': 'Mode de paiement',
  'global.order_no': 'Référence',
  'global.rates': 'Tarifs',
  'global.agency_staff': "Personnel de l'agence",
  'global.add_agency_staff': "Ajouter le personnel de l'agence",
  'global.create_return_route': 'Ajouter un itinéraire de retour',
  'global.settings': 'Paramètres',
  'global.label': 'Libellé :',
  'global.value': 'Valeur',
  'global.create_price_ddd': 'Ajouter un prix DDD',
  'global.recentActivity': 'Journal',
  'global.username': "nom d'utilisateur",
  'global.tax': 'Taxe',
  'global.day': 'Jour',
  'global.booking_statistic': 'Report de voyage',
  'global.trajet_id': 'ID du trajet',
  'global.group_route': 'Grouper par itinéraire',
  'global.default': 'Système par défaut',
  'global.sms_payment': 'Payer',
  'global.ticket_settings': 'Paramètres du billet',
  'global.code_type': 'Type de code',
  'global.qr_code': 'Code QR',
  'global.bar_code': 'Code-barres',
  'global.filling_rate': 'Taux de remplissage',
  'global.trips': 'Voyages',
  'order.reseller': 'Reseller',
  'order.booking_time': 'Booking time',
  'order.rebook': 'Réservation',
  'global.add_new_customer': 'Ajouter passager',
  'global.payment_methods': 'liste des moyens de paiement',
  'global.departure_info': 'informations de voyage',
  'route.create': 'Créer une route',
  'global.valider': 'Valider',
  'global.sms_gateway': 'passerelle SMS',
  'global.orangeSms': 'Orange SMS',
  'global.mtargetSms': 'Mtarget SMS',

  'global.month': 'mois',
  'global.route_code': 'Route',
  'global.depart_time': 'Heure Départ',
  'global.arrival_time': 'Heure Arrivée',
  'global.current_price': 'Prix',
  'global.bus': 'Véhicule',
  'global.bus_type': 'Véhicule Statut',
  'global.export': 'Exporter',
  'select.convoyeur': 'Convoyeur',
  'select.partner_manager': 'Partner Manager',
  'select.partner_admin': 'Partner Admin',
  'select.supervisor': 'Superviseur',
  'select.manager': 'Manager',
  'select.admin': 'Admin',
  'select.operator': 'Opérateur',
  'select.cashier': 'Caissier',
  'global.identify': 'Identifiant',

  'global.required_field_firstname': 'Le prénom est requis',
  'global.required_field_lastname': 'Le nom de famille est requis',
  'global.required_field_email': "L'email est requis",
  'global.required_field_mobile': 'Le mobile est requis',
  'global.required_field_password': 'Le mot de passe est requis',
  'global.required_field_confirm_password':
    'Confirmer le mot de passe est requis',
  'global.required_field_company_name': "Le nom de l'entreprise est requis",
  'global.required_field_company_shortname':
    "Le nom abrégé de l'entreprise est requis",
  'global.required_field_role': 'Le rôle est requis',

  'global.sale_status': 'Actif/Désactivé',
  'global.sale_fee': 'Commission',
  'global.sale_currency_main': 'Devise',
  'global.sale_currency_symbol': 'Symbole',
  'global.sale_currency_display': 'Affichage devise',
  'global.sale_currency_decimald': 'Décimal',

  'global.cancel_hold_time': 'Délai annulation réservation',
  'global.limit_order_days': 'Délai limite de réservation',
  'global.limit_order_minutes': 'Temps limite de réservation',

  'global.sale_edit_enable': 'Actif/Désactivé',
  'global.sale_edit_days': 'Voyage',
  'global.sale_edit_times': 'Nombre de changement',

  'global.enable_disable': 'Activer/Désactiver',
  'global.enable': 'Activer',
  'global.disable': 'Inactif',
  'global.select_status_enable_disable': 'Sélectionner le statut',
  'global.select_enable': 'Sélectionner Activer',
  'global.select_disable': 'Sélectionner Désactiver',
  'global.template_sms': 'SMS Template',
  'global.sms': 'SMS',
  'global.message': 'Message',
  'global.smsActivity': 'Sms Activity',
  'global.number_sms': 'Nombre de SMS envoyés',
  'global.provider': 'Fournisseur',
  'global.account': 'Compte ',
  'global.passwords_do_not_match': 'Les mots de passe ne correspondent pas',

  'global.global': 'Résumé',
  'global.number_of_paid_ticket': 'Nombre de billets payés',
  'global.number_of_unpaid_ticket': 'Nombre de billets non payés',
  'global.total_revenue': 'Revenu total',
  'global.total_debt_amount': 'Montant total de la dette',
  'global.total_general': 'Total général',
  'global.bagages_name': 'Bagages',
  'global.calendar_edit': 'Ajouter un départ',
};
